if (!customElements.get("highlight-text-image")) {
  class HighLightTextImage extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.templates = this.section
        .querySelector("template")
        .content.cloneNode(true);

      this.images = {};
    }

    connectedCallback() {
      this.init();

      this.highlight = this.querySelector("em.highlight-text");
      this.getHighlightText();

      requestAnimationFrame(() => {
        // this.splitTextToLines();
        this.initScrollAnimation();
      });
    }

    getHighlightText() {
      if (this.highlight) {
        this.highlight.dataset.text = this.highlight.innerText;
      }
    }

    init() {
      let contentHTML = this.innerHTML;

      contentHTML = contentHTML.replace(/\s*\[img\d+\]\s*/g, (match) =>
        match.trim()
      );

      const images = this.templates.querySelectorAll("[data-id]");

      images.forEach((image) => {
        const key = image.dataset.id;
        this.images[key] = image;
      });

      contentHTML = contentHTML.replace(/\[img(\d+)\]/g, (match, p1) => {
        const imgIndex = `img${p1}`;
        const imageWrapper = this.images[imgIndex];
        if (imageWrapper) {
          return imageWrapper.innerHTML.trim();
        }
        return match;
      });

      this.innerHTML = contentHTML;
    }

    splitTextToLines() {
      const el = this.highlight;
      if (!el) return;

      const text = el.innerText;
      el.innerHTML = "";

      const words = text.split(" ");
      let line = document.createElement("span");
      line.classList.add("line");
      el.appendChild(line);

      words.forEach((word) => {
        const testLine = line.innerText + word + " ";
        line.innerText = testLine;

        if (line.scrollWidth > el.clientWidth) {
          line.innerText = line.innerText.trim();

          line = document.createElement("span");
          line.classList.add("line");
          line.innerText = word + " ";
          el.appendChild(line);
        }
      });
    }

    initScrollAnimation() {
      const el = this.highlight;
      if (!el) return;

      const update = () => {
        const rect = el.getBoundingClientRect();

        let progress = 1 - rect.top / window.innerHeight;

        progress = Math.max(0, Math.min(progress, 1));

        el.style.setProperty("--progress", progress);
      };

      window.addEventListener("scroll", update);
      update();
    }
  }

  customElements.define("highlight-text-image", HighLightTextImage);
}